"use strict";

var _taggedTemplateLiteral = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _objectSpread = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _objectWithoutProperties = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _chunk575KBOSDjs = require('./chunk-575KBOSD.js');

var _chunkTPZR5EWLjs = require('./chunk-TPZR5EWL.js');

var _chunkFKBTJYRFjs = require('./chunk-FKBTJYRF.js');

var _chunkCEAA42VMjs = require('./chunk-CEAA42VM.js');

var _chunkNESC3UD7js = require('./chunk-NESC3UD7.js');

var _react = require('react');

var _styledcomponents = require('styled-components');

var _styledcomponents2 = _interopRequireDefault(_styledcomponents);

var _jsxruntime = require('react/jsx-runtime');

var D = _react.forwardRef.call(void 0, function (o, a) {
  var _chunk575KBOSDjs$c$ca = _chunk575KBOSDjs.c.call(void 0, o),
      r = _chunk575KBOSDjs$c$ca.containerProps,
      y = _chunk575KBOSDjs$c$ca.FormComponentWrapper,
      d = _chunk575KBOSDjs$c$ca.formComponentWrapperProps,
      h = _chunk575KBOSDjs$c$ca.rest,
      s = h.disabled,
      t = h.onClear,
      _h$placeholder = h.placeholder,
      P = _h$placeholder === void 0 ? " " : _h$placeholder,
      c = h.prefix,
      _h$showClearIcon = h.showClearIcon,
      g = _h$showClearIcon === void 0 ? !!t : _h$showClearIcon,
      I = h.small,
      b = h.suffix,
      k = _objectWithoutProperties(h, ["disabled", "onClear", "placeholder", "prefix", "showClearIcon", "small", "suffix"]),
      w = g && !!t;

  return _jsxruntime.jsx.call(void 0, y, _objectSpread({}, d, {
    children: _jsxruntime.jsxs.call(void 0, v, _objectSpread({}, r, {
      $hasError: d.hasError,
      $small: I,
      disabled: s,
      children: [!!c && _jsxruntime.jsx.call(void 0, p, {
        color: "weak",
        children: c
      }), _jsxruntime.jsx.call(void 0, S, _objectSpread({
        type: "text"
      }, k, {
        disabled: s,
        placeholder: P,
        ref: a
      })), !!b && _jsxruntime.jsx.call(void 0, p, {
        color: "weak",
        children: b
      }), w && _jsxruntime.jsx.call(void 0, i, {
        color: "default",
        hoverColor: "hover",
        onClick: t,
        role: "button"
      })]
    }))
  }));
}),
    i = exports.b = _styledcomponents2.default.call(void 0, _chunkCEAA42VMjs.a)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: none;\n"]))),
    p = exports.c = _styledcomponents2.default.call(void 0, _chunkTPZR5EWLjs.g)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([""]))),
    v = exports.d = _styledcomponents2.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    padding: 0 8px;\n    column-gap: 4px;\n    border-radius: ", ";\n\n    input:not(:placeholder-shown) ~ ", " {\n        display: block;\n    }\n\n    ", "\n\n    ", ";\n\n    ", ";\n"])), function (_ref) {
  var o = _ref.theme;
  return o.input.border.radius;
}, i, function (_ref2) {
  var o = _ref2.$small;
  return o ? _styledcomponents.css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n                  height: 34px;\n                  padding: ;\n              "]))) : _styledcomponents.css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n                  height: 42px;\n              "])));
}, function (_ref3) {
  var o = _ref3.$hasError,
      a = _ref3.disabled,
      r = _ref3.theme;
  return _chunkNESC3UD7js.f.call(void 0, {
    base: _styledcomponents.css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n                background-color: ", ";\n                border: 1px solid ", ";\n                cursor: text;\n\n                ", "\n            "])), r.color.background.field.default, r.color.border.divider.default, o && _styledcomponents.css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n                    border-color: ", ";\n                "])), r.color.border.critical)),
    disabled: _styledcomponents.css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n                border: 1px solid ", ";\n                background-color: ", ";\n\n                ", " {\n                    pointer-events: none;\n                    path {\n                        fill: ", ";\n                    }\n                }\n\n                ", ", input {\n                    background-color: ", ";\n                    color: ", ";\n                }\n            "])), r.color.border.disabled, r.color.background.disabled, i, r.color.icon.disabled, p, r.color.background.disabled, r.color.text.disabled),
    focus: _styledcomponents.css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n                border-color: ", ";\n            "])), r.color.border.focused.default),
    focusPrefix: ":has(input:focus)",
    hover: _styledcomponents.css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n                border-color: ", ";\n            "])), r.color.border.hover),
    isDisabled: a
  });
}, _chunkNESC3UD7js.e),
    S = exports.e = _styledcomponents2.default.input(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n    ", "\n    outline: none;\n    border: none;\n    width: 100%;\n\n    ", "\n\n    ::placeholder {\n        color: ", ";\n    }\n"])), function (_ref4) {
  var o = _ref4.theme;
  return _chunkFKBTJYRFjs.a.call(void 0, {
    $typographySpecKey: "body.primary",
    theme: o
  });
}, function (_ref5) {
  var o = _ref5.type;
  return o === "number" && _styledcomponents.css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n            &::-webkit-outer-spin-button,\n            &::-webkit-inner-spin-button {\n                -webkit-appearance: none;\n                margin: 0;\n            }\n\n            &[type='number'] {\n                -moz-appearance: textfield;\n            }\n        "])));
}, function (_ref6) {
  var o = _ref6.theme;
  return o.color.text.inactive;
});

exports.a = D;
exports.b = i;
exports.c = p;
exports.d = v;
exports.e = S;